export default "__VITE_ASSET__BJY$Kisp__"